var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { getCommaSeparatedValues } from "../../utilities";
export function useDeleteSharableFile() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (sharableFileId) => __awaiter(this, void 0, void 0, function* () {
            return yield axios.delete(window.DjUrls["sharing:update_destroy_sharable_file"](sharableFileId));
        }),
        onMutate: (fileId) => {
            queryClient.setQueryData(["users"], (prevUsers) => prevUsers === null || prevUsers === void 0 ? void 0 : prevUsers.filter((file) => file.id !== fileId));
        },
        onSettled: () => queryClient.invalidateQueries({ queryKey: ["users"] }),
    });
}
export function useGetSharableFiles(scope) {
    return useQuery({
        queryKey: ["users", scope],
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            const res = yield axios.get(window.DjUrls["sharing:my_repository_list_sharable_files"]() +
                `?scope=${scope}`);
            return res.data;
        }),
        refetchOnWindowFocus: false,
    });
}
export function useCreateSharableFile(formValues, scope) {
    var _a, _b, _c, _d;
    const queryClient = useQueryClient();
    const formData = new FormData();
    formData.append("display_name", (_a = formValues.display_name) !== null && _a !== void 0 ? _a : "");
    formData.append("description", (_b = formValues.description) !== null && _b !== void 0 ? _b : "");
    formData.append("file_type", (_c = formValues.file_type) !== null && _c !== void 0 ? _c : "");
    formData.append("file", (_d = formValues.file) !== null && _d !== void 0 ? _d : "");
    (formValues.shared_to_original
        ? getCommaSeparatedValues(formValues.shared_to_original)
        : []).forEach((user) => {
        formData.append("shared_to_original", user);
    });
    formData.append("scope", scope);
    return useMutation({
        // because the table type binds the backend queries to specific types,
        // and our create endpoint takes different fields then a table row has,
        // we use a custom useState to save our custom create form fields values.
        mutationFn: (file) => __awaiter(this, void 0, void 0, function* () {
            return axios.post(window.DjUrls["sharing:create_sharable_file"](), formData);
        }),
        onSettled: () => queryClient.invalidateQueries({ queryKey: ["users"] }),
    });
}
export function useUpdateSharableFile(formValuesCopy, scope) {
    const queryClient = useQueryClient();
    const sharedToOriginal = formValuesCopy.shared_to_original;
    delete formValuesCopy.shared_to_original;
    const formData = axios.toFormData(formValuesCopy);
    formData.append("scope", scope);
    if (sharedToOriginal) {
        getCommaSeparatedValues(sharedToOriginal).forEach((user) => {
            formData.append("shared_to_original", user);
        });
    }
    return useMutation({
        mutationFn: (sharableFile) => __awaiter(this, void 0, void 0, function* () {
            return yield axios.patch(window.DjUrls["sharing:update_destroy_sharable_file"](sharableFile.id), formData);
        }),
        onSettled: () => queryClient.invalidateQueries({ queryKey: ["users"] }),
    });
}
